export default ($axios) => ({
  fetch(query) {
    return $axios.get('/webchat/departments', { params: query });
  },
});
